'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgActionFilter = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m18.43 6 1.09-3h-2.13l-2.91 8h2.13l1.09-3H22V6h-3.57ZM14.7 6H2v2h11.97l.73-2ZM7.39 13 6.3 16H2v2h3.57l-1.09 3h2.13l2.91-8H7.39ZM9.3 18H22v-2H10.03l-.73 2Z" })
);

module.exports = SvgActionFilter;
//# sourceMappingURL=ActionFilter.cjs.js.map
